// src/features/message/messageSlice.js

import { createSlice } from "@reduxjs/toolkit";

const messageSlice = createSlice({
  name: "message",
  initialState: {
    showMessage: false,
    message: "",
    type: "info",
  },
  reducers: {
    showMessage: (state, action) => {
      state.showMessage = true;
      state.message = action.payload.message;
      state.type = action.payload.type || "info";
    },
    hideMessage: (state) => {
      state.showMessage = false;
      state.message = "";
      state.type = "";
    },
  },
});

export const { showMessage, hideMessage } = messageSlice.actions;
export default messageSlice.reducer;
